module.exports = __webpack_public_path__ + "media/images/cherry_bkg-d4e61de09703da826ea9b03c4b12b78b.jpg";